export interface MessageNegotiate {
  id: string;
  parentId : string;
  senderId: string;
  isCreator: boolean;
  sender: string;
  content: string;
  createTime: Date;
  attachments: File[];
  type?: number;
  parent?: MessageNegotiate;
  mergeFields?: MergeFieldHistory[];
  historyInvalid?: boolean;
  historyHasMore?: boolean;
}

export interface MergeFieldHistory {
  fieldConfigId: number | string;
  fieldName: string;
  mergeField: string;
  oldValue: string;
  newValue: string;
}

export function isChatSubmitKey(event: { key: string; shiftKey: boolean; isComposing?: boolean }): boolean {
  return event.key === 'Enter' && !event.shiftKey && !event.isComposing;
}

export function getNegotiateCopyText(message: MessageNegotiate): string {
  if (message.type !== 2) {
    return message.content || '';
  }
  return (message.mergeFields || []).map(field =>
    field.fieldName + ': ' + (field.oldValue !== '' ? field.oldValue + ' → ' : '') + field.newValue
  ).join('\n');
}

export function mapNegotiateMessage(item: any, emptyValueLabel = '(Trống)'): MessageNegotiate {
  const type = Number(item.type) === 2 ? 2 : 1;
  const enterpriseName = item.contractEnterpriseName === item.name ? null : item.contractEnterpriseName;
  const userName = typeof item.name === 'string' ? item.name.trim() : '';
  const message: MessageNegotiate = {
    ...item,
    type,
    senderId: item.userId,
    sender: [enterpriseName, type === 2 ? userName : item.name, item.phone].filter(Boolean).join(' - '),
    attachments: Array.isArray(item.attachments) ? item.attachments : [],
    parent: item.parent ? mapNegotiateMessage(item.parent, emptyValueLabel) : null,
    mergeFields: []
  };
  if (type === 2) {
    try {
      const history = typeof item.content === 'string' ? JSON.parse(item.content) : item.content;
      const fields = Array.isArray(history) ? history : history && history.mergeFields;
      if (!Array.isArray(fields)) {
        throw new Error('Invalid merge field history');
      }
      message.mergeFields = fields.filter(field => field && typeof field === 'object').map(field => ({
        fieldConfigId: field.fieldConfigId,
        fieldName: String(field.fieldName || field.mergeField || (field.fieldConfigId == null ? '' : field.fieldConfigId)),
        mergeField: field.mergeField,
        oldValue: formatMergeHistoryValue(field.oldValue, emptyValueLabel),
        newValue: formatMergeHistoryValue(field.newValue, emptyValueLabel)
      }));
      message.historyInvalid = message.mergeFields.length === 0;
      message.historyHasMore = message.mergeFields.length > 10;
    } catch (_) {
      message.historyInvalid = true;
    }
  }
  return message;
}

function formatMergeHistoryValue(value: any, emptyValueLabel: string): string {
  if (Array.isArray(value)) {
    return value.length ? value.map(item => formatMergeHistoryValue(item, emptyValueLabel)).join(', ') : emptyValueLabel;
  }
  if (value == null || (typeof value === 'string' && !value.trim())) {
    return emptyValueLabel;
  }
  return typeof value === 'object' ? formatMergeHistoryValue(value.value, emptyValueLabel) : String(value);
}

